import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './components/App'
import { CssBaseline } from '@material-ui/core'
import registerServiceWorker from './registerServiceWorker'

import * as Sentry from '@sentry/browser'
const VERSION = '0.8.1'
if (process.env.NODE_ENV !== 'test') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY,
    release: `signFront@${VERSION}`
  })
}
ReactDOM.render(<div>
  <CssBaseline />
  <App />
</div>, document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js